export const LOCALE_STORAGE_KEY = 'civic-champs-admin.locale'
